import LazyImage from 'components/LazyImage/LazyImage'

export default LazyImage
